import React, { useState } from 'react';
import { Image } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@components/Icons';

const ImageGalleryMobile = ({ images_parkingAt }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images_parkingAt.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + images_parkingAt.length) % images_parkingAt.length
    );
  };

  // Image list removing the current (biggest)
  const filteredImages = images_parkingAt.filter(
    (_, index) => index !== currentIndex
  );

  return (
    <div className="w-full">
      {images_parkingAt[currentIndex] && (
        <div className="relative w-full h-72 md:h-[32rem] mb-2">
          <Image
            preview={false}
            src={images_parkingAt[currentIndex].image_url}
            alt={images_parkingAt[currentIndex].image_description}
            height="100%"
          />

          {images_parkingAt.length > 1 && (
            <>
              <button
                className="absolute top-1/2 left-4 p-2.5 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center hover:bg-white"
                onClick={prevImage}
              >
                <ArrowLeftOutlined className="text-xl font-bold text-gray-700" />
              </button>
              <button
                className="absolute top-1/2 right-4 p-2.5 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center hover:bg-white"
                onClick={nextImage}
              >
                <ArrowRightOutlined className="text-xl font-bold text-gray-700" />
              </button>
            </>
          )}
        </div>
      )}

      {filteredImages.length > 0 && (
        <div
          className={`
            grid grid-cols-${filteredImages.length} 
            overflow-x-auto gap-x-1 p-1 justify-center items-center justify-items-center h-44`}
        >
          {filteredImages.map((image, index) => (
            <div
              key={index}
              className="w-full h-full flex justify-center"
              onClick={() => setCurrentIndex(images_parkingAt.indexOf(image))}
            >
              <Image
                preview={false}
                src={image.image_url}
                alt={image.image_description}
                className="rounded-md w-full h-32"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGalleryMobile;
